// @flow
import type {Node} from 'react';
import {useLocation, matchPath} from 'react-router-dom';
import {TabBar} from 'components/TabbedPage';

// Thin wrapper over the shared TabBar, kept until the Members and Staff pages
// move onto TabbedPage (ENG-5567).
export type MembersTabType = {
  path: string,
  label: string,
  count?: number,
};

type PropsType = {
  tabs: Array<MembersTabType>,
  ariaLabel: string,
};

export const MembersTabBar = ({tabs, ariaLabel}: PropsType): Node => {
  const {pathname} = useLocation();
  // Paths are matched exactly, so only the active tab matches; fall back to the
  // first tab (e.g. the index "All" route) when nothing matches.
  const activeTab =
    tabs.find(({path}) => matchPath(path, pathname) !== null) ?? tabs[0];

  return <TabBar tabs={tabs} activeTab={activeTab} ariaLabel={ariaLabel} />;
};
